import React from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import { useHistory } from 'react-router-dom';
import { rackRegistryCreateService } from 'services/rackregistry';
import NetworkToolWrapper from '../../layouts/NetworkToolWrapper';
import { MyBreadcrumb } from 'utils';
import { PageHeader } from 'antd';
import RackRegistryForm from './form';

const { Option } = Select;

const RackRegistryCreate = () => {
  const history = useHistory();

  const onFinish = async (values) => {
    try {
      await rackRegistryCreateService(values);
      message.success('Rack registry created successfully');
      history.push('/rackregistry');
    } catch (error) {
      message.error('Failed to create rack registry');
    }
  };

  return (
    <NetworkToolWrapper isBranchClientRequired={false}>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Networking Dashboard', path: '/network-dashboard' },
          { label: 'Rack Registry', path: '/rackregistry' },
          { label: 'Create Rack Registry', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => history.push('/rackregistry')}
        title="Create Rack Registry"
        subTitle=""
      >
        <RackRegistryForm onFinish={onFinish} />
      </PageHeader>
    </NetworkToolWrapper>
  );
};

export default RackRegistryCreate;
